/**
 * @file: useBackButtonHandler.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { useNavigation } from '@react-navigation/native';
import { useCallback } from 'react';

export const useBackButtonHandler = () => {
  const navigation = useNavigation();
  return useCallback(() => {
    navigation.goBack();
  }, [navigation]);
};
